// UserContext.js
import React, { createContext, useState, useContext } from "react";

const NotesContext = createContext();

export const NotesContextProvider = ({ children }) => {
    const [itemNotes, setItemNotes] = useState({});

    const updateNote = (itemId, note) => {
        setItemNotes((prevNotes) => ({
          ...prevNotes,
          [itemId]: note,
        }));
      };
  return (
    <NotesContext.Provider value={{ updateNote, itemNotes }}>
      {children}
    </NotesContext.Provider>
  );
};

export const UseItemNotes = () => {
  const context = useContext(NotesContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
